import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { subWeeks, addWeeks, startOfWeek, endOfWeek, differenceInCalendarWeeks, isWithinInterval } from 'date-fns';

import TimeslotGrid from '../../Booking/TimeslotGrid';
import WeeklyDateScroller from '../../../../components/common/WeeklyDateScroller';
import { BookingDescription } from '../../Components/Booking/BookingDescription';
import { ErrorDiv } from './ErrorDiv';

export const SelectBookingTime=({
    setSelectedBookings,
    selectedBookings,
    checkServiceAndUserTokens,
    userTokens,
    activeService,
    setDateWeek,
    dateWeek,
    setSelectedLocation,
    selectedUser,
    selectedLocation, 
    getEventConflicts,
    conflictEvents,
    handleError,
    errors,
    lateBooking=false,
    onLateBookingChange=null,
    ...props
})=>{

    const [disabled, setDisabled]=useState(false)

    useEffect(()=>{
        if(differenceInCalendarWeeks(dateWeek, new Date()) === 0) setDisabled(true);
        else setDisabled(false);
    },[dateWeek])

    const handleSlotChange=(slots)=>{
        setSelectedBookings(slots);
        checkServiceAndUserTokens(userTokens, activeService?.products, slots)
    }

    const onChangeDate=(selectedDate)=>{
        setDateWeek(startOfWeek(new Date(selectedDate)))
        setSelectedBookings([])
    }

    const isInRange = (date) => {
        return isWithinInterval(
            date,
            { start: new Date(startOfWeek(dateWeek)), end: new Date(endOfWeek(dateWeek)) }
        )
    }

    const handleSelectedLocation=(location)=>{
        setSelectedLocation(location)
        getEventConflicts(null, location.id);
    }
    

    return(
        <>
            {activeService &&
                <BookingDescription 
                    service={activeService}
                    tokens={[]}
                    linkToBundles={null}
                />
            }
            <hr />
            <div className="d-flex flex-column align-items-center">
                <p>
                    {activeService &&
                        activeService?.location_info?.map((info)=>(
                            <Button key={`location-${info.id}`} onClick={()=>handleSelectedLocation(info)}>
                                {info?.name}
                            </Button>
                        ))
                    } 
                </p>
                <p>
                    Selected Location: {selectedLocation.name}
                </p>
                {onLateBookingChange &&
                    <Form.Check
                        type="switch"
                        id="late-booking-switch"
                        className="mb-2"
                        data-cy="late-booking-switch"
                        label="This session already happened (book it after the fact)"
                        checked={lateBooking}
                        onChange={(e)=>onLateBookingChange(e.target.checked)}
                    />
                }
                {lateBooking &&
                    <p className="text-muted small">
                        Showing sessions that have already started. Full sessions can still be picked, and no booking emails are sent.
                    </p>
                }
                <WeeklyDateScroller
                    backDisabled={disabled && !lateBooking}
                    smallScreen={false}
                    selectedDate={null}
                    onDateBack={()=>setDateWeek(subWeeks(dateWeek, 1))}
                    onDateNext={()=>setDateWeek(addWeeks(dateWeek, 1))}
                    onChangeDate={(selected)=>onChangeDate(selected)}
                    rangeStartDate={startOfWeek(dateWeek)}
                    rangeEndDate={endOfWeek(dateWeek)}
                    isInRange={isInRange}
                />
            </div>
            {activeService && selectedUser && selectedLocation &&         
                <TimeslotGrid 
                    location={selectedLocation}
                    startDate={startOfWeek(dateWeek)}
                    endDate={endOfWeek(dateWeek)}
                    minHour={6}
                    maxHour={18}
                    conflictEvents={conflictEvents}              
                    service={activeService}
                    showConflictInfo={true}
                    onSlotChange={(change)=>handleSlotChange(change.selected_slots)}
                    importedSelectedSlots={selectedBookings}
                    allowPast={lateBooking}
                    key={lateBooking ? "late" : "normal"}
                />
            }
            <ErrorDiv errors={errors} />
        </>
    )
}